var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "blur",
            rawName: "v-blur",
            value: _vm.blurConfig,
            expression: "blurConfig",
          },
        ],
        staticClass: "mmp-app-container",
      },
      [
        _vm.showLoadingScreen
          ? _c("MMP_LoadingScreen", {
              staticClass: "loading",
              attrs: { user: _vm.user },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("MMP_NavBar", {
          ref: "mmpNavBar",
          attrs: {
            mapsMode: _vm.mapsMode,
            versionReleaseInfo: _vm.versionReleaseInfo,
          },
          on: {
            showDashboard: function ($event) {
              return _vm.showDashboard()
            },
            showMap: function ($event) {
              return _vm.showMap()
            },
            navAction: function ($event) {
              return _vm.handleNavAction($event)
            },
            initHDTAdminConsole: function ($event) {
              return _vm.initHDTAdminConsole()
            },
            clearCurrentPositionsInterval: function ($event) {
              return _vm.removeCurrentPositionsInterval()
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mmp-main-content" },
          [
            !_vm.mapsMode
              ? _c("MMP_Dashboard", {
                  attrs: {
                    user: _vm.user,
                    isUshrUser: _vm.isUshrUser,
                    versionReleaseInfo: _vm.versionReleaseInfo,
                  },
                  on: {
                    showMap: function ($event) {
                      return _vm.showMap()
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mmp-maps-content",
                class: { "mmp-maps-hidden": !_vm.mapsMode },
              },
              [
                _c("div", { staticClass: "no-scroll" }, [
                  _c(
                    "div",
                    { staticClass: "map" },
                    [
                      _c("div", {
                        ref: "mapRef",
                        staticClass: "ol-map ol-map-home",
                        attrs: { id: "map" },
                      }),
                      _vm._v(" "),
                      _vm.mapsMode
                        ? _c(
                            "div",
                            { staticClass: "mmp-top-right-bar" },
                            [
                              _c("MMP_ZoomLevel", { attrs: { map: _vm.map } }),
                              _vm._v(" "),
                              _vm.ansiComponent
                                ? _c("MMP_ANSI_NightModeToggle", {
                                    attrs: { active: _vm.nightMode },
                                    on: {
                                      toggle: function ($event) {
                                        return _vm.toggleNightMode()
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.mapsMode
                                ? _c("MMP_Tools", {
                                    attrs: {
                                      map: _vm.map,
                                      mapsMode: _vm.mapsMode,
                                      clickedCoords: _vm.clickedCoords,
                                      showMeasuringTool: _vm.showMeasuringTool,
                                      measurement: _vm.measurement,
                                      selectedExtent: _vm.selectedExtent,
                                    },
                                    on: {
                                      addPoint: function ($event) {
                                        return _vm.addPoint($event)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.finishedLoadingFlags[3]
                                ? _c("MMP_Widgets", {
                                    ref: "tools",
                                    attrs: {
                                      map: _vm.map,
                                      zoomLevel: _vm.zoomLevel,
                                      pointVectorSource: _vm.pointVectorSource,
                                      ansiComponent: _vm.ansiComponent,
                                      drtComponents: _vm.drtComponents,
                                      showToggle: _vm.showToggle,
                                      user: _vm.user,
                                      homeScreenComponents:
                                        _vm.homeScreenComponents,
                                      selectedExtent: _vm.selectedExtent,
                                      baseMapsOpen: _vm.baseMapsOpen,
                                      currentBaseMap: _vm.currentBaseMap,
                                      extentsOpen: _vm.extentsOpen,
                                      showLidarPanel: _vm.showLidarPanel,
                                      lidarMinZoomAchieved:
                                        _vm.lidarMinZoomAchieved,
                                      showMeasuringTool: _vm.showMeasuringTool,
                                      analyticsVisible: _vm.analyticsVisible,
                                      wclVisible: _vm.wclVisible,
                                      distinct_lidar: _vm.distinct_lidar,
                                      extentName: _vm.selectedExtent,
                                      lidarIsLoading: _vm.lidarIsLoading,
                                    },
                                    on: {
                                      zoomLevelChanged: function ($event) {
                                        _vm.map.getView().setZoom($event)
                                      },
                                      addPoint: function ($event) {
                                        return _vm.addPoint($event)
                                      },
                                      showToggle: function ($event) {
                                        _vm.showToggle = true
                                      },
                                      getVectorlayer: function ($event) {
                                        return _vm.getVectorlayer($event)
                                      },
                                      toggleChange: function ($event) {
                                        return _vm.toggleChange($event)
                                      },
                                      extentsExpandChange: function ($event) {
                                        return _vm.extentsExpandChange($event)
                                      },
                                      extentChanged: function ($event) {
                                        return _vm.extentChanged($event)
                                      },
                                      baseMapsExpandChange: function ($event) {
                                        return _vm.baseMapsExpandChange($event)
                                      },
                                      toggleBaseLayer: function ($event) {
                                        return _vm.toggleBaseLayer($event)
                                      },
                                      lidarToggleChange: function ($event) {
                                        return _vm.toggleLidarPanel()
                                      },
                                      toggleMeasuringTool: function ($event) {
                                        _vm.showMeasuringTool =
                                          !_vm.showMeasuringTool
                                      },
                                      measurement: function ($event) {
                                        _vm.measurement = $event
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mapsMode
                        ? _c(
                            "div",
                            { staticClass: "mmp-top-left-bar" },
                            [
                              _vm.highwayDBcloudComponents
                                ? _c("MMP_HWDB_Layers", {
                                    staticClass: "hwdbLayersList",
                                    attrs: {
                                      id: "HighwayDBCloudLayerList",
                                      grouped: _vm.grouped,
                                      highwayDBcloudLayersButtonsCtrl:
                                        _vm.highwayDBcloudLayersButtonsCtrl,
                                      highwayDBcloudSubcategory:
                                        _vm.highwayDBcloudSubcategory,
                                      map: _vm.map,
                                      mmp_layersObj: _vm.mmp_layersObj,
                                      spinnerManager: _vm.spinnerManager,
                                    },
                                    on: {
                                      btnClass: function ($event) {
                                        return _vm.btnClass($event)
                                      },
                                      DLLChange: function ($event) {
                                        return _vm.onResizeMainMenuOrDLL()
                                      },
                                      toggleLayerVisibility: function ($event) {
                                        return _vm.toggleLayerVisibility($event)
                                      },
                                      unloadLayers: function ($event) {
                                        return _vm.unloadLayers($event)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.drtComponents &&
                              !_vm.homeScreenComponents &&
                              _vm.showDrtLayersPanel
                                ? _c("MMP_DRT_Layers", {
                                    ref: "DRTLayers",
                                    staticClass: "layersList",
                                    style: _vm.layersListMaxHeight,
                                    attrs: {
                                      id: "DRTDynamicLayerList",
                                      customerName: _vm.customerName,
                                      customerProjectId: _vm.customerProjectId,
                                      dataset: _vm.selectedDataset,
                                      drtLayersButtonsCtrl:
                                        _vm.drtLayersButtonsCtrl,
                                      layersListMaxHeight:
                                        _vm.layersListMaxHeight,
                                      layerResponse: _vm.layerResponse,
                                      map: _vm.map,
                                      mmp_layersObj: _vm.mmp_layersObj,
                                      olSelectkey: _vm.olSelectkey,
                                      otonomoSubcountry: _vm.otonomoSubcountry,
                                      persistingLayerFilters:
                                        _vm.persistingLayerFilters,
                                      selectedExtent: _vm.selectedExtent,
                                      showDRTLayers: _vm.showDRTLayers,
                                      spinnerManager: _vm.spinnerManager,
                                      user: _vm.user,
                                      zoomEnded: _vm.zoomEnded,
                                      zoomLevelCap: _vm.zoomLevelCap,
                                      showLidarPanel: _vm.showLidarPanel,
                                      baseMapsOpen: _vm.baseMapsOpen,
                                      extentsOpen: _vm.extentsOpen,
                                    },
                                    on: {
                                      removeLayerListener:
                                        _vm.removeAttributesWindowListener,
                                      DLLChange: function ($event) {
                                        return _vm.onResizeMainMenuOrDLL()
                                      },
                                      getErrorsLayer: function ($event) {
                                        return _vm.getErrorsLayer($event)
                                      },
                                      getLegend: function ($event) {
                                        return _vm.getLegend($event)
                                      },
                                      getReleases: function ($event) {
                                        return _vm.getReleases($event)
                                      },
                                      getShowAttributes: function ($event) {
                                        return _vm.getShowAttributes($event)
                                      },
                                      layerButtonsChanged: function ($event) {
                                        _vm.drtLayersButtonsCtrl = $event
                                      },
                                      loadAttributes: function ($event) {
                                        return _vm.loadAttributes($event)
                                      },
                                      rulesChanged: function ($event) {
                                        _vm.persistingLayerFilters = $event
                                      },
                                      toggleErrorsLayerVisibility: function (
                                        $event
                                      ) {
                                        return _vm.toggleErrorsLayerVisibility()
                                      },
                                      toggleLayerVisibility: function ($event) {
                                        return _vm.toggleLayerVisibility($event)
                                      },
                                      toTopOfList: function ($event) {
                                        return _vm.putLayerOnTop($event)
                                      },
                                      unloadLayers: function ($event) {
                                        return _vm.unloadLayers($event)
                                      },
                                      updateZoomEnded: function ($event) {
                                        _vm.zoomEnded = $event
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ansiComponent && !_vm.homeScreenComponents
                                ? _c("MMP_ANSI_Layers", {
                                    ref: "ansiLayers",
                                    staticClass: "ansi-layersList",
                                    attrs: {
                                      id: "ANSIDynamicLayerList",
                                      ansiLayersButtonCtrl:
                                        _vm.ansiLayersButtonCtrl,
                                      currentANSIPartNumber:
                                        _vm.currentANSIPartNumber,
                                      currentANSISelset: _vm.ansiSelectedSelset,
                                      customerName: _vm.customerName,
                                      customerProjectId: _vm.customerProjectId,
                                      isUshrUser: _vm.isUshrUser,
                                      layersListMaxHeight:
                                        _vm.layersListMaxHeight,
                                      layerResponse: _vm.layerResponse,
                                      map: _vm.map,
                                      user: _vm.user,
                                      mmp_layersObj: _vm.mmp_layersObj,
                                      olSelectkey: _vm.olSelectkey,
                                      otonomoSubcountry: _vm.otonomoSubcountry,
                                      persistingLayerFilters:
                                        _vm.persistingLayerFilters,
                                      selectedExtent: _vm.selectedExtent,
                                      spinnerManager: _vm.spinnerManager,
                                      zoomEnded: _vm.zoomEnded,
                                      zoomLevelCap: _vm.zoomLevelCap,
                                      layerDefinition: _vm.layerDefinition,
                                      showLidarPanel: _vm.showLidarPanel,
                                      baseMapsOpen: _vm.baseMapsOpen,
                                      extentsOpen: _vm.extentsOpen,
                                      showStreetView: _vm.showStreetView,
                                      currentAnsiSegment:
                                        _vm.currentAnsiSegment,
                                      otonomoFeatureTableSubcountry:
                                        _vm.otonomoFeatureTableSubcountry,
                                      otonomoEditedSubcountry:
                                        _vm.otonomoEditedSubcountry,
                                      otonomoFilters: _vm.otonomoFilters,
                                    },
                                    on: {
                                      removeLayerListener:
                                        _vm.removeAttributesWindowListener,
                                      clearAnsiSelection: function ($event) {
                                        return _vm.clearAnsiSelection()
                                      },
                                      clearSpinnerManager: function ($event) {
                                        _vm.spinnerManager = []
                                      },
                                      DLLChange: function ($event) {
                                        return _vm.onResizeMainMenuOrDLL()
                                      },
                                      getLayers: function ($event) {
                                        return _vm.getLayers(
                                          $event.release_id,
                                          $event.store_name,
                                          $event.workspace,
                                          $event.delivery_coverage_store,
                                          $event.part_number
                                        )
                                      },
                                      getLegend: function ($event) {
                                        return _vm.getLegend($event)
                                      },
                                      getShowAttributes: function ($event) {
                                        return _vm.getShowAttributes($event)
                                      },
                                      gotANSIReleases: function ($event) {
                                        _vm.ansiReleases = $event
                                      },
                                      layerButtonsChanged: function ($event) {
                                        _vm.ansiLayersButtonCtrl = $event
                                      },
                                      loadAttributes: function ($event) {
                                        return _vm.loadAttributes($event)
                                      },
                                      onResize: function ($event) {
                                        return _vm.onResize()
                                      },
                                      rulesChanged: function ($event) {
                                        _vm.persistingLayerFilters = $event
                                      },
                                      toggleLayerVisibility: function ($event) {
                                        return _vm.toggleLayerVisibility($event)
                                      },
                                      toTopOfList: function ($event) {
                                        return _vm.putLayerOnTop($event)
                                      },
                                      updateANSILayersPartNumber: function (
                                        $event
                                      ) {
                                        return _vm.updateANSILayersPartNumber(
                                          $event
                                        )
                                      },
                                      unloadLayers: function ($event) {
                                        return _vm.unloadLayers($event)
                                      },
                                      updateZoomEnded: function ($event) {
                                        _vm.zoomEnded = $event
                                      },
                                      saveOtonomoRules: function ($event) {
                                        _vm.otonomoFilters = $event
                                      },
                                      getAnsiSelectedSelset: function ($event) {
                                        return _vm.getAnsiSelectedSelset($event)
                                      },
                                      getGSV: function ($event) {
                                        return _vm.getGSV($event)
                                      },
                                      initANSIFeatureTable: function ($event) {
                                        _vm.initANSIFeatureTable = $event
                                      },
                                      initBiasedFeatureTable: function (
                                        $event
                                      ) {
                                        _vm.initBiasedFeatureTable = $event
                                      },
                                      initBIASEDReports: function ($event) {
                                        return _vm.initBIASEDReports()
                                      },
                                      initANSIReports: function ($event) {
                                        return _vm.initANSIReports()
                                      },
                                      initIntersectionReports: function (
                                        $event
                                      ) {
                                        return _vm.initIntersectionReports()
                                      },
                                      otonomoToggledOff: function ($event) {
                                        _vm.otonomoSubcountry = null
                                      },
                                      setOtonomoSubcountryNames: function (
                                        $event
                                      ) {
                                        return _vm.setOtonomoSubcountryNames(
                                          $event
                                        )
                                      },
                                      subcountryChanged: function ($event) {
                                        _vm.otonomoFeatureTableSubcountry = null
                                      },
                                      toggleGSV: function ($event) {
                                        return _vm.toggleGSV($event)
                                      },
                                      updateAnsiLayerName: function ($event) {
                                        _vm.ansiLayerName = $event
                                      },
                                      updateANSISelset: function ($event) {
                                        _vm.ansiSelset = $event
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.layerLegend &&
                              !_vm.analyticsVisible &&
                              !_vm.wclVisible
                                ? _c("MMP_LayerLegend", {
                                    attrs: {
                                      id: "layerLegend",
                                      layerLegendMaxHeight:
                                        _vm.layerLegendMaxHeight,
                                      layerLegendName: _vm.layerLegendName,
                                      legendImgSrc: _vm.legendImgSrc,
                                      legendMinimized: _vm.layerLegendMinimized,
                                    },
                                    on: {
                                      aspectRatio: function ($event) {
                                        return _vm.setLayerLegendAspectRatio(
                                          $event
                                        )
                                      },
                                      closeLegend: function ($event) {
                                        return _vm.closeLegend()
                                      },
                                      initResize: function ($event) {
                                        return _vm.onResizeMainMenuOrDLL()
                                      },
                                      maximizeLegend: function ($event) {
                                        return _vm.maxOrMinLegend(false)
                                      },
                                      minimizeLegend: function ($event) {
                                        return _vm.maxOrMinLegend(true)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.ansiComponent
                        ? _c("MMP_ANSI_Navigation", {
                            ref: "ansiNav",
                            staticClass: "navigation-icons-positions",
                            attrs: {
                              ansiLayersButtonCtrl: _vm.ansiLayersButtonCtrl,
                              map: _vm.map,
                              customerProjectId: _vm.customerProjectId,
                              layerDefinition: _vm.layerDefinition,
                              apiUrl: _vm.apiUrl,
                              currentANSIPartNumber: _vm.currentANSIPartNumber,
                            },
                            on: {
                              closeAnsiTestingWindow: function ($event) {
                                _vm.ansiTestingVisible = false
                              },
                              ansiSegmentChange: function ($event) {
                                return _vm.zoomToSegment($event)
                              },
                              toggleLayer: function ($event) {
                                return _vm.toggleLayerVisibility($event)
                              },
                              setSpeedLimit: function ($event) {
                                return _vm.setSpeedLimitSegment($event)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentAnsiSegment
                        ? _c("MMP_ANSI_SpeedLimit", {
                            staticClass: "mmp-tools-speed-limit",
                            attrs: {
                              currentAnsiSegment: _vm.currentAnsiSegment,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "grid-layout",
                        {
                          ref: "mainLayout",
                          attrs: {
                            id: "mainLayout",
                            layout: _vm.layout,
                            "col-num": 12,
                            "row-height": 30,
                            "is-draggable": true,
                            "is-resizable": true,
                            responsive: true,
                            "use-css-transforms": true,
                            "vertical-compact": false,
                            "prevent-collision": true,
                            margin: [0, 0],
                            "restore-on-drag": true,
                          },
                          on: {
                            "update:layout": function ($event) {
                              _vm.layout = $event
                            },
                          },
                        },
                        [
                          _vm.eodFieldReviewVisible
                            ? _c("MMP_EODFieldReview", {
                                attrs: {
                                  id: "eodFieldReview",
                                  map: _vm.map,
                                  eodFieldReviewVisible:
                                    _vm.eodFieldReviewVisible,
                                  layersListMaxHeight: _vm.layersListMaxHeight,
                                  isAdmin: _vm.isAdmin,
                                  user: _vm.user,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("MMP_FleetioVehicles", {
                            attrs: { extent: _vm.selectedExtent },
                            on: {
                              vehicleSelected: function ($event) {
                                return _vm.zoomToVehicle($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("MMP_DPR_EntryManager", {
                            ref: "EntryRef",
                            attrs: {
                              dprUpdateInfo: _vm.dprUpdateInfo,
                              isAdmin: _vm.isAdmin,
                              user: _vm.user,
                            },
                          }),
                          _vm._v(" "),
                          _c("MMP_DPR_Reports", {
                            attrs: { extents: _vm.extentResponse },
                          }),
                          _vm._v(" "),
                          _c("MMP_DPR_AdminConsole", {
                            ref: "AdminConsoleRef",
                            attrs: { user: _vm.user, isAdmin: _vm.isAdmin },
                            on: {
                              updateUser: function ($event) {
                                return _vm.setUserId($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("MMP_HDT_AdminConsole", {
                            ref: "hdtAdminConsoleRef",
                          }),
                          _vm._v(" "),
                          _c("MMP_DPR", {
                            ref: "DprRef",
                            attrs: { isAdmin: _vm.isAdmin, user: _vm.user },
                            on: {
                              dprUpdated: function ($event) {
                                return _vm.setDprUpdateInfo($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("MMP_MapSettings", {
                            attrs: {
                              isUshrUser: _vm.isUshrUser,
                              userOrg: _vm.user.org,
                            },
                            on: {
                              clicked: function ($event) {
                                return _vm.zoomLevelSaved($event)
                              },
                              extentChanged: function ($event) {
                                return _vm.extentChanged($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("MMP_ChangePassword"),
                          _vm._v(" "),
                          _c("MMP_HDT_HardDriveTracking"),
                          _vm._v(" "),
                          _c("MMP_DRT_ushrUserSelectDRT", {
                            ref: "DRTSelectionRef",
                            attrs: { isUshrUser: _vm.isUshrUser },
                            on: {
                              datasetSelect: function ($event) {
                                return _vm.initTool($event)
                              },
                              returnHome: function ($event) {
                                return _vm.showDashboard()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("MMP_ANSI_ushrUserSelectANSI", {
                            ref: "ANSISelectionRef",
                            on: {
                              datasetSelect: function ($event) {
                                return _vm.initTool($event)
                              },
                              returnHome: function ($event) {
                                return _vm.showDashboard()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("MMP_DatasetSelection", {
                            attrs: {
                              ansiComponent: _vm.ansiComponent,
                              ansiLayersButtonCtrl: _vm.ansiLayersButtonCtrl,
                              ansiReleases: _vm.ansiReleases,
                              ansiSelset: _vm.ansiSelset,
                              apiUrl: _vm.apiUrl,
                              customerName: _vm.customerName,
                              drtComponents: _vm.drtComponents,
                              releases: _vm.releases,
                              selectedDataset: _vm.selectedDataset,
                              selectedExtent: _vm.selectedExtent,
                              user: _vm.user,
                            },
                            on: {
                              extentChanged: function ($event) {
                                return _vm.extentChanged($event)
                              },
                              returnHome: function ($event) {
                                return _vm.showDashboard()
                              },
                              setSelectedDataset: function ($event) {
                                _vm.selectedDataset = $event
                                _vm.currentAnsiSegment = null
                              },
                              setShowDRTLayers: function ($event) {
                                _vm.showDRTLayers = true
                              },
                              updateANSILayersPartNumber: function ($event) {
                                return _vm.updateANSILayersPartNumber($event)
                              },
                              updateDRTLayersPartNumber: function ($event) {
                                return _vm.updateDRTLayersPartNumber($event)
                              },
                              updateSelset: function ($event) {
                                return _vm.updateANSIToolsSelset($event)
                              },
                              unloadLayers: function ($event) {
                                return _vm.unloadLayers($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("MMP_UserAccountControl", {
                            ref: "UACRef",
                            attrs: {
                              newGroupAdded: _vm.newGroupAdded,
                              user: _vm.user,
                            },
                            on: {
                              resetGroupAddedFeedback: function ($event) {
                                return _vm.resetGroupAddedFeedback()
                              },
                              updateUser: function ($event) {
                                return _vm.setUserId($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("MMP_VersionRelease"),
                          _vm._v(" "),
                          _c("MMP_Deliveries"),
                          _vm._v(" "),
                          _c("MMP_AccessControl", {
                            attrs: { user: _vm.user },
                            on: { refreshUserModules: _vm.refreshUserModules },
                          }),
                          _vm._v(" "),
                          _vm.drtComponents
                            ? _c("MMP_DRT_ErrorControl", {
                                staticClass: "error-control-panel",
                                attrs: {
                                  customerProjectId: _vm.customerProjectId,
                                  drt_releaseId: _vm.drt_releaseId,
                                  error: _vm.error,
                                  errorsLayerVisibility:
                                    _vm.errorsLayerVisibility,
                                  errLat: _vm.errLat,
                                  errLayer: _vm.errLayer,
                                  errLong: _vm.errLong,
                                  legendImgSrc: _vm.errorsLayerLegend,
                                  releases: _vm.releases,
                                  selectedDataset: _vm.selectedDataset,
                                  updateError: _vm.updateError,
                                  updateErrorDataSource:
                                    _vm.updateErrorDataSource,
                                  user: _vm.user,
                                  map: _vm.map,
                                },
                                on: {
                                  exportFile: function ($event) {
                                    return _vm.exportFile($event)
                                  },
                                  initDRTErrorManager: function ($event) {
                                    return _vm.initDRTErrorManager()
                                  },
                                  toggleError: function ($event) {
                                    return _vm.toggleError()
                                  },
                                  toggleUpdateError: function ($event) {
                                    return _vm.toggleUpdateError()
                                  },
                                  refresh: function ($event) {
                                    return _vm.refreshLayer($event)
                                  },
                                  notification: function ($event) {
                                    return _vm.sendErrorNotification($event)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("MMP_ANSI_FeatureTable", {
                            ref: "AnsiFeatureTableRef",
                            attrs: {
                              apiUrl: _vm.apiUrl,
                              ansiSelectedSelset: _vm.ansiSelectedSelset,
                              map: _vm.map,
                              hdLayerSelected: _vm.hdLayerSelected,
                              currentANSIPartNumber: _vm.currentANSIPartNumber,
                              layerDefinition: _vm.layerDefinition,
                              user: _vm.user,
                            },
                            on: {
                              changeOtonomoSubcountry: function ($event) {
                                return _vm.changeOtonomoSubcountry($event)
                              },
                              toggleLidarPanel: function ($event) {
                                return _vm.toggleLidarPanel($event)
                              },
                              setSpeedLimit: function ($event) {
                                return _vm.setSpeedLimitSegment(
                                  $event.selected_item
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("MMP_ANSI_Reports", {
                            ref: "AnsiReportsRef",
                            attrs: {
                              ansiLayerName: _vm.ansiLayerName,
                              ansiSelectedSelset: _vm.ansiSelectedSelset,
                              apiUrl: _vm.apiUrl,
                              mmp_layersObj: _vm.mmp_layersObj,
                              currentANSIPartNumber: _vm.currentANSIPartNumber,
                              layerDefinition: _vm.layerDefinition,
                              extent: _vm.selectedExtent,
                            },
                          }),
                          _vm._v(" "),
                          _c("MMP_Biased_Reports", {
                            ref: "BiasedAnsiReportsRef",
                            attrs: {
                              ansiLayerName: _vm.ansiLayerName,
                              ansiSelectedSelset: _vm.ansiSelectedSelset,
                              apiUrl: _vm.apiUrl,
                              mmp_layersObj: _vm.mmp_layersObj,
                              currentANSIPartNumber: _vm.currentANSIPartNumber,
                              layerDefinition: _vm.layerDefinition,
                              extent: _vm.selectedExtent,
                              customerProjectId: _vm.customerProjectId,
                            },
                          }),
                          _vm._v(" "),
                          _c("MMP_Intersection_Reports", {
                            ref: "IntersectionReportsRef",
                            attrs: {
                              ansiLayerName: _vm.ansiLayerName,
                              ansiSelectedSelset: _vm.ansiSelectedSelset,
                              apiUrl: _vm.apiUrl,
                              mmp_layersObj: _vm.mmp_layersObj,
                              currentANSIPartNumber: _vm.currentANSIPartNumber,
                              layerDefinition: _vm.layerDefinition,
                            },
                          }),
                          _vm._v(" "),
                          _c("MMP_ScriptAutomation", { ref: "ScriptsRef" }),
                          _vm._v(" "),
                          _c("MMP_WmsSelectModal"),
                          _vm._v(" "),
                          _c("MMP_NewUserModal", {
                            ref: "newUserModalRef",
                            attrs: { user: _vm.user },
                          }),
                          _vm._v(" "),
                          _c("MMP_UpdateUserModal", {
                            ref: "updateUserModalRef",
                            attrs: { user: _vm.user, userId: _vm.userId },
                            on: { refresh: _vm.refreshUAC },
                          }),
                          _vm._v(" "),
                          _c("MMP_NewGroupModal", {
                            on: {
                              newGroupAdded: function ($event) {
                                return _vm.groupAddedChange($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("MMP_ReleaseNotes", { ref: "ReleaseNotesRef" }),
                          _vm._v(" "),
                          _c("MMP_DPRAutomation"),
                          _vm._v(" "),
                          _c("MMP_ReleaseHistory", {
                            attrs: { user: this.user },
                          }),
                          _vm._v(" "),
                          _vm.showFeatureButtons && _vm.homeScreenComponents
                            ? _c("MMP_MainFeatureButtons", {
                                attrs: { user: _vm.user, isAdmin: _vm.isAdmin },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "Moveable",
                            _vm._b(
                              {
                                staticClass: "moveable",
                                on: {
                                  drag: function ($event) {
                                    return _vm.handleDrag($event)
                                  },
                                },
                              },
                              "Moveable",
                              _vm.moveable,
                              false
                            ),
                            [
                              _vm.ansiTestingVisible && !_vm.drtComponents
                                ? _c("MMP_ANSI_Testing", {
                                    ref: "AnsiTestingRef",
                                    staticClass: "ansiTestingComponent",
                                    attrs: {
                                      id: "AnsiTestingWindow",
                                      apiUrl: _vm.apiUrl,
                                      layerDefinition: _vm.layerDefinition,
                                      hdLayerSelected: _vm.hdLayerSelected,
                                      user: this.user,
                                      selectedExtent: _vm.selectedExtent,
                                    },
                                    on: {
                                      setSpeedLimit: function ($event) {
                                        _vm.currentAnsiSegment = $event
                                      },
                                      closeAnsiTestingWindow:
                                        _vm.closeAnsiTestingWindow,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Moveable",
                            _vm._b(
                              {
                                staticClass: "moveable",
                                on: {
                                  drag: function ($event) {
                                    return _vm.handleDrag($event)
                                  },
                                },
                              },
                              "Moveable",
                              _vm.moveable,
                              false
                            ),
                            [
                              _vm.intrsectionTestingVisible &&
                              !_vm.drtComponents
                                ? _c("MMP_Intersection_Testing", {
                                    ref: "IntersectionTestingRef",
                                    staticClass: "ansiTestingComponent",
                                    attrs: {
                                      id: "IntersectionTestingWindow",
                                      apiUrl: _vm.apiUrl,
                                      layerDefinition: _vm.layerDefinition,
                                      user: this.user,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Moveable",
                            _vm._b(
                              {
                                staticClass: "moveable",
                                on: {
                                  drag: function ($event) {
                                    return _vm.handleDrag($event)
                                  },
                                },
                              },
                              "Moveable",
                              _vm.moveable,
                              false
                            ),
                            [
                              _vm.biasedTestingVisible && !_vm.drtComponents
                                ? _c("MMP_Biased_Testing", {
                                    ref: "BiasedTestingRef",
                                    staticClass: "ansiTestingComponent",
                                    attrs: {
                                      id: "BiasedTestingWindow",
                                      apiUrl: _vm.apiUrl,
                                      layerDefinition: _vm.layerDefinition,
                                      clickedLayerName: _vm.clickedLayerName,
                                      user: this.user,
                                    },
                                    on: {
                                      closeBiasedAnsiTestingWindow:
                                        _vm.closeBiasedAnsiTestingWindow,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Moveable",
                            _vm._b(
                              {
                                staticClass: "moveable gsv-window",
                                on: {
                                  drag: function ($event) {
                                    return _vm.handleDrag($event)
                                  },
                                },
                              },
                              "Moveable",
                              _vm.moveable,
                              false
                            ),
                            [
                              _vm.ansiComponent && _vm.showStreetView
                                ? _c(
                                    "div",
                                    { attrs: { id: "googleStreetViewPanel" } },
                                    [
                                      _c(
                                        "b-row",
                                        {
                                          staticClass:
                                            "justify-content-md-left pl-3",
                                        },
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "usv-symbols",
                                              attrs: {
                                                cols: "12",
                                                md: "auto",
                                                id: "clickToDragColGSV",
                                              },
                                            },
                                            [
                                              _c("fa", {
                                                attrs: {
                                                  icon: ["fas", "arrows-alt"],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("MMP_ANSI_GoogleStreetView", {
                                        attrs: { iFrameSrc: _vm.iFrameSrc },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "Moveable",
                            _vm._b(
                              {
                                staticClass: "moveable gsv-window",
                                on: {
                                  drag: function ($event) {
                                    return _vm.handleDrag($event)
                                  },
                                },
                              },
                              "Moveable",
                              _vm.moveable,
                              false
                            ),
                            [
                              _vm.ansiComponent &&
                              _vm.showUshrStreetView &&
                              (_vm.streetViewSrc1 || _vm.streetViewSrc2)
                                ? _c(
                                    "div",
                                    { attrs: { id: "ushrStreetViewPanel" } },
                                    [
                                      _c(
                                        "b-row",
                                        { staticClass: "usv-buttons" },
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "usv-symbols",
                                              attrs: { id: "clickToDragCol" },
                                            },
                                            [
                                              _c("fa", {
                                                attrs: {
                                                  icon: ["fas", "arrows-alt"],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "usv-symbols",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getNextCameraImagery(
                                                    1
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("fa", {
                                                attrs: {
                                                  icon: ["fas", "chevron-up"],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "usv-symbols",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getNextCameraImagery(
                                                    -1
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("fa", {
                                                attrs: {
                                                  icon: ["fas", "chevron-down"],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            {
                                              staticClass:
                                                "usv-symbols usv-close",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.closeUSV()
                                                },
                                              },
                                            },
                                            [
                                              _c("fa", {
                                                attrs: {
                                                  icon: ["fas", "window-close"],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("MMP_ANSI_UshrStreetView", {
                                        attrs: {
                                          streetViewSrc1: _vm.streetViewSrc1,
                                          streetViewSrc2: _vm.streetViewSrc2,
                                          ushrImageryAttributeData:
                                            _vm.ushrImageryAttributeData,
                                        },
                                        on: {
                                          streetViewChanged: function ($event) {
                                            _vm.USVImgStyle = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "Moveable",
                            _vm._b(
                              {
                                staticClass: "moveable gsv-window",
                                on: {
                                  drag: function ($event) {
                                    return _vm.handleDrag($event)
                                  },
                                },
                              },
                              "Moveable",
                              _vm.moveable,
                              false
                            ),
                            [
                              _vm.ansiComponent &&
                              _vm.showLadybugStreetView &&
                              _vm.ladybugSrc1
                                ? _c(
                                    "div",
                                    { attrs: { id: "ladybugStreetViewPanel" } },
                                    [
                                      _c(
                                        "b-row",
                                        { staticClass: "usv-buttons" },
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "usv-symbols",
                                              attrs: { id: "clickToDragCol" },
                                            },
                                            [
                                              _c("fa", {
                                                attrs: {
                                                  icon: ["fas", "arrows-alt"],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "usv-symbols",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getNextLadybugCameraImagery(
                                                    1
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("fa", {
                                                attrs: {
                                                  icon: ["fas", "chevron-up"],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "usv-symbols",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getNextLadybugCameraImagery(
                                                    -1
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("fa", {
                                                attrs: {
                                                  icon: ["fas", "chevron-down"],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            {
                                              staticClass:
                                                "usv-symbols usv-close",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.closeLadybugSV()
                                                },
                                              },
                                            },
                                            [
                                              _c("fa", {
                                                attrs: {
                                                  icon: ["fas", "window-close"],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("MMP_ANSI_LadybugStreetView", {
                                        attrs: {
                                          ladybugSrc1: _vm.ladybugSrc1,
                                          ladybugImageryAttributeData:
                                            _vm.ladybugImageryAttributeData,
                                        },
                                        on: {
                                          streetViewChanged: function ($event) {
                                            _vm.ladybugSVImgStyle = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "Moveable",
                            _vm._b(
                              {
                                staticClass: "moveable attribute-table",
                                on: {
                                  drag: function ($event) {
                                    return _vm.handleDrag($event)
                                  },
                                },
                              },
                              "Moveable",
                              _vm.moveable,
                              false
                            ),
                            [
                              _vm.showAttributes &&
                              !_vm.analyticsVisible &&
                              !_vm.wclVisible
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "moveable-container-attributes",
                                      attrs: { id: "attributes" },
                                    },
                                    [
                                      _c("MMP_Attributes", {
                                        attrs: {
                                          attributesName: _vm.attributesName,
                                          attributesMinimized:
                                            _vm.attributesPanelMinimized,
                                          attribResponse: _vm.attribResponse,
                                          customerProjectId:
                                            _vm.customerProjectId,
                                          features: _vm.features,
                                          feature_index: _vm.feature_index,
                                          map: _vm.map,
                                          resetSequentialErrorButtons:
                                            _vm.resetSequentialErrorButtons,
                                          otonomoEditedSubcountry:
                                            _vm.otonomoEditedSubcountry,
                                          user: _vm.user,
                                        },
                                        on: {
                                          closeAttTable: function ($event) {
                                            return _vm.closeAttTable()
                                          },
                                          errorButtonsReset: function ($event) {
                                            _vm.resetSequentialErrorButtons = false
                                          },
                                          gotError: function ($event) {
                                            return _vm.gotErrorFromAttributes(
                                              $event
                                            )
                                          },
                                          maximizeAttributes: function (
                                            $event
                                          ) {
                                            return _vm.maxOrMinAttributes(false)
                                          },
                                          minimizeAttributes: function (
                                            $event
                                          ) {
                                            return _vm.maxOrMinAttributes(true)
                                          },
                                          showNextAttribute: function ($event) {
                                            return _vm.showNextAttribute($event)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("MMP_InactivityWarning", {
                  attrs: { timeBeforeLogout: _vm.timeBeforeLogout },
                }),
                _vm._v(" "),
                _c("MMP_GTP_TrackingVue"),
                _vm._v(" "),
                _c("MMP_ImageCarousel"),
                _vm._v(" "),
                _c("MMP_GTP_Report"),
                _vm._v(" "),
                _c("MMP_Biased_FeatureTable", {
                  ref: "BiasedFeatureTableRef",
                  attrs: {
                    apiUrl: _vm.apiUrl,
                    ansiSelectedSelset: _vm.ansiSelectedSelset,
                    map: _vm.map,
                    hdLayerSelected: _vm.hdLayerSelected,
                    currentANSIPartNumber: _vm.currentANSIPartNumber,
                    layerDefinition: _vm.layerDefinition,
                    user: _vm.user,
                    customerProjectId: _vm.customerProjectId,
                  },
                  on: {
                    changeOtonomoSubcountry: function ($event) {
                      return _vm.changeOtonomoSubcountry($event)
                    },
                    toggleLidarPanel: function ($event) {
                      return _vm.toggleLidarPanel($event)
                    },
                  },
                }),
                _vm._v(" "),
                _c("MMP_HotkeysInfo", {
                  staticClass: "hotkeys-positioning",
                  attrs: { hotkeysInfoVisible: _vm.hotkeysInfoVisible },
                  on: {
                    toggleHotkeys: function ($event) {
                      _vm.hotkeysInfoVisible = !_vm.hotkeysInfoVisible
                    },
                  },
                }),
                _vm._v(" "),
                _vm.analyticsVisible && !_vm.homeScreenComponents
                  ? _c("MMP_Analytics_Upload", {
                      staticClass: "upload-position",
                      attrs: {
                        user: _vm.user,
                        wclLayersButtonsCtrl: _vm.wclLayersButtonsCtrl,
                        selectedExtent: _vm.selectedExtent,
                        extentResponse: _vm.extentResponse,
                      },
                      on: {
                        refresh: function ($event) {
                          return _vm.refreshPOI()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("MMP_Analytics_MileageSlider", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.analyticsVisible &&
                        !_vm.homeScreenComponents &&
                        _vm.showslider,
                      expression:
                        "analyticsVisible && !homeScreenComponents && showslider",
                    },
                  ],
                  ref: "mileageSliderRef",
                  staticClass: "slider-position",
                  on: {
                    sliderChange: _vm.updateRadius,
                    toggleSlider: _vm.toggleSlider,
                    calculateMileage: _vm.calculateMileage,
                    unitChange: _vm.changeMileageUnit,
                  },
                }),
                _vm._v(" "),
                _vm.analyticsVisible && !_vm.homeScreenComponents
                  ? _c("MMP_Analytics_ToolBar", {
                      staticClass: "toolbar-position",
                      attrs: { zoomLevel: _vm.zoomLevel, map: _vm.map },
                      on: {
                        returnHome: function ($event) {
                          return _vm.reset()
                        },
                        toggleSlider: _vm.toggleSlider,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "Moveable",
                  _vm._b(
                    {
                      staticClass: "moveable analytics-attribute-table",
                      on: {
                        drag: function ($event) {
                          return _vm.handleDrag($event)
                        },
                      },
                    },
                    "Moveable",
                    _vm.moveable,
                    false
                  ),
                  [
                    _vm.showAnalyticsAttributes
                      ? _c(
                          "div",
                          { attrs: { id: "analytics_attributes" } },
                          [
                            _c("MMP_Analytics_Attributes", {
                              attrs: {
                                attributesName: _vm.attributesName,
                                attributesMinimized:
                                  _vm.attributesPanelMinimized,
                                anaAttribResponse: _vm.anaAttribResponse,
                                customerProjectId: _vm.customerProjectId,
                                features: _vm.features,
                                feature_index: _vm.feature_index,
                                map: _vm.map,
                                resetSequentialErrorButtons:
                                  _vm.resetSequentialErrorButtons,
                                anaSliderVal: _vm.anaSliderVal,
                                isAnaKilo: _vm.isAnaKilo,
                                layerName: _vm.wclLayersButtonsCtrl.find(
                                  (layer) => layer.name == "POI Uploads"
                                ).display_name,
                              },
                              on: {
                                closeAnaAttTable: function ($event) {
                                  return _vm.closeAnaAttTable()
                                },
                                errorButtonsReset: function ($event) {
                                  _vm.resetSequentialErrorButtons = false
                                },
                                gotError: function ($event) {
                                  return _vm.gotErrorFromAttributes($event)
                                },
                                maximizeAttributes: function ($event) {
                                  return _vm.maxOrMinAttributes(false)
                                },
                                minimizeAttributes: function ($event) {
                                  return _vm.maxOrMinAttributes(true)
                                },
                                showNextAttribute: function ($event) {
                                  return _vm.showNextAttribute($event)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm.analyticsVisible && !_vm.homeScreenComponents
                  ? _c("MMP_Analytics_Layers", {
                      staticClass: "wclLayersList",
                      style: _vm.layersListMaxHeight,
                      attrs: {
                        id: "AnalyticsDLL",
                        customerName: _vm.customerName,
                        customerProjectId: _vm.customerProjectId,
                        dataset: _vm.selectedDataset,
                        analyticsVisible: _vm.analyticsVisible,
                        wclLayersButtonsCtrl: _vm.wclLayersButtonsCtrl,
                        layersListMaxHeight: _vm.layersListMaxHeight,
                        layerResponse: _vm.layerResponse,
                        map: _vm.map,
                        mmp_layersObj: _vm.mmp_layersObj,
                        olSelectkey: _vm.olSelectkey,
                        otonomoSubcountry: _vm.otonomoSubcountry,
                        persistingLayerFilters: _vm.persistingLayerFilters,
                        selectedExtent: _vm.selectedExtent,
                        showDRTLayers: _vm.showDRTLayers,
                        spinnerManager: _vm.spinnerManager,
                        user: _vm.user,
                        zoomEnded: _vm.zoomEnded,
                        zoomLevelCap: _vm.zoomLevelCap,
                        showLidarPanel: _vm.showLidarPanel,
                        baseMapsOpen: _vm.baseMapsOpen,
                        extentsOpen: _vm.extentsOpen,
                      },
                      on: {
                        DLLChange: function ($event) {
                          return _vm.onResizeMainMenuOrDLL()
                        },
                        getErrorsLayer: function ($event) {
                          return _vm.getErrorsLayer($event)
                        },
                        getReleases: function ($event) {
                          return _vm.getReleases($event)
                        },
                        getShowAttributes: function ($event) {
                          return _vm.getShowAttributes($event)
                        },
                        layerButtonsChanged: function ($event) {
                          _vm.drtLayersButtonsCtrl = $event
                        },
                        loadAttributes: function ($event) {
                          return _vm.loadAttributes($event)
                        },
                        rulesChanged: function ($event) {
                          _vm.persistingLayerFilters = $event
                        },
                        toggleErrorsLayerVisibility: function ($event) {
                          return _vm.toggleErrorsLayerVisibility()
                        },
                        toggleLayerVisibility: function ($event) {
                          return _vm.toggleLayerVisibility($event)
                        },
                        toTopOfList: function ($event) {
                          return _vm.putLayerOnTop($event)
                        },
                        unloadLayers: function ($event) {
                          return _vm.unloadLayers($event)
                        },
                        updateZoomEnded: function ($event) {
                          _vm.zoomEnded = $event
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.wclVisible && !_vm.homeScreenComponents
                  ? _c("MMP_WCL_Layers", {
                      staticClass: "wclLayersList",
                      style: _vm.layersListMaxHeight,
                      attrs: {
                        id: "wclDLL",
                        customerName: _vm.customerName,
                        customerProjectId: _vm.customerProjectId,
                        dataset: _vm.selectedDataset,
                        analyticsVisible: _vm.analyticsVisible,
                        wclVisible: _vm.wclVisible,
                        wclLayersButtonsCtrl: _vm.wclLayersButtonsCtrl,
                        layersListMaxHeight: _vm.layersListMaxHeight,
                        layerResponse: _vm.layerResponse,
                        map: _vm.map,
                        mmp_layersObj: _vm.mmp_layersObj,
                        olSelectkey: _vm.olSelectkey,
                        otonomoSubcountry: _vm.otonomoSubcountry,
                        persistingLayerFilters: _vm.persistingLayerFilters,
                        selectedExtent: _vm.selectedExtent,
                        showDRTLayers: _vm.showDRTLayers,
                        spinnerManager: _vm.spinnerManager,
                        user: _vm.user,
                        zoomEnded: _vm.zoomEnded,
                        zoomLevelCap: _vm.zoomLevelCap,
                        showLidarPanel: _vm.showLidarPanel,
                        baseMapsOpen: _vm.baseMapsOpen,
                        extentsOpen: _vm.extentsOpen,
                      },
                      on: {
                        DLLChange: function ($event) {
                          return _vm.onResizeMainMenuOrDLL()
                        },
                        getErrorsLayer: function ($event) {
                          return _vm.getErrorsLayer($event)
                        },
                        getLegend: function ($event) {
                          return _vm.getLegend($event)
                        },
                        getReleases: function ($event) {
                          return _vm.getReleases($event)
                        },
                        getShowAttributes: function ($event) {
                          return _vm.getShowAttributes($event)
                        },
                        layerButtonsChanged: function ($event) {
                          _vm.drtLayersButtonsCtrl = $event
                        },
                        loadAttributes: function ($event) {
                          return _vm.loadAttributes($event)
                        },
                        rulesChanged: function ($event) {
                          _vm.persistingLayerFilters = $event
                        },
                        toggleErrorsLayerVisibility: function ($event) {
                          return _vm.toggleErrorsLayerVisibility()
                        },
                        toggleLayerVisibility: function ($event) {
                          return _vm.toggleLayerVisibility($event)
                        },
                        toTopOfList: function ($event) {
                          return _vm.putLayerOnTop($event)
                        },
                        unloadLayers: function ($event) {
                          return _vm.unloadLayers($event)
                        },
                        updateZoomEnded: function ($event) {
                          _vm.zoomEnded = $event
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("head", [
      _c("meta", {
        attrs: { "http-equiv": "Cache-Control", content: "no-cache" },
      }),
      _vm._v(" "),
      _c("meta", { attrs: { "http-equiv": "Pragma", content: "no-cache" } }),
      _vm._v(" "),
      _c("meta", { attrs: { "http-equiv": "Expires", content: "0" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }